import { ResourceKind } from "@gen/tracker/v1/common_pb";
import { CatalogPicker, type CatalogKind } from "@/components/canonical/pickers/catalog-picker";

interface ResourcePickerProps {
  scopeKind: ResourceKind;
  value: string;
  onChange: (id: string) => void;
  disabled?: boolean;
}

/** The catalog a snippet scope picks its target from. */
const SCOPE_CATALOG: Partial<Record<ResourceKind, CatalogKind>> = {
  [ResourceKind.LANDER]: "lander",
  [ResourceKind.OFFER]: "offer",
  [ResourceKind.CAMPAIGN]: "campaign",
  [ResourceKind.TRAFFIC_SOURCE]: "source",
};

// ResourcePicker picks the snippet's target from the catalog its scope names,
// searched over all of it — a lander, an offer, a campaign or a source.
export function ResourcePicker({ scopeKind, value, onChange, disabled }: ResourcePickerProps) {
  const kind = SCOPE_CATALOG[scopeKind];
  if (!kind) return null;
  return <CatalogPicker key={kind} kind={kind} value={value || undefined} onChange={onChange} disabled={disabled} />;
}
